<template>
  <div class="layout-header-dropdown-menu">
    <el-dropdown trigger="click" @command="handleCommand" @visible-change="handleVisibleChange">
      <div class="info-wrap">
        <div class="user-avatar">
          <img v-show="!!avatar" :src="avatar">
          <i v-show="!avatar" class="layout layout-user"></i>
        </div>
        <p class="user-name">{{ user.name }}</p>
      </div>
      <el-dropdown-menu slot="dropdown" class="layout-header-dropdown">
        <el-dropdown-item class="user-info-wrap" disabled>
          <div class="user-info">
            <div class="user-avatar">
              <img v-show="!!avatar" :src="avatar">
              <i v-show="!avatar" class="layout layout-user"></i>
            </div>
            <div class="user">
              <p class="user-name">{{ user.name }}</p>
              <span class="user-duty">{{ user.department || user.duty }}</span>
            </div>
          </div>
        </el-dropdown-item>
        <div class="header-user-dropitem-wrap">
          <template v-for="item in dropdownItems">
            <div v-if="item.type === 'divider'" :key="item.key" class="header-user-dropitem-line"></div>
            <el-dropdown-item v-if="item.type !== 'divider' && (!item.visible || item.visible())" :key="item.key"
              :command="item.command" :title="item.title || ''" :data-clk-logkey="item.logKey || ''">
              <template v-if="item.isSwitch">
                <div class="switch-item">
                  <div>
                    <i class="header-user-dropitem layout" :class="item.icon" />{{ item.label }}
                  </div>
                  <el-switch :width="35" :value="item.switchValue()" active-color="#6d2ef8" inactive-color="#d2d2d6">
                  </el-switch>
                </div>
              </template>
              <template v-else-if="item.component">
                <OfficeNetBoard v-if="item.command === 'OfficeNetBoard'" />
              </template>
              <template v-else>
                <i class="header-user-dropitem layout" :class="item.icon" />{{ item.label }}
              </template>
            </el-dropdown-item>
          </template>
        </div>
        <el-dropdown-item command="logout" class="logout-item-wrap">
          <div class="logout-btn">退出登录</div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <kye-dialog :title="dialogOptions.title" :width="dialogOptions.width" :visible.sync="dialogOptions.visible"
      append-to-body :view.sync="dialogOptions.view" :showFullScreenButton="hiddenFullScreenAndResizeFlag"
      :canResize="hiddenFullScreenAndResizeFlag" :before-close="closeHelper">
      <component :is="dialogOptions.view" @close="closeHelper" :helper="dialogOptions.helper" :url="dialogOptions.url"
        :upgradeLogList="upgradeLogList">
      </component>
    </kye-dialog>
    <Theme2 ref="theme" />
  </div>
</template>

<script>
import mixins from 'public/mixins'
import localforage from 'localforage'
import AccountList from './account-list-dialog'
import Theme2 from './theme2.vue'
import UpdateSystemName from './update-system-name.vue'
import OfficeNetBoard from './office-net-board.vue'
import RemoveConfigDialog from './remove-config-dialog.vue'
import { themeSystem } from '@/layout/layout/setup/theme-system/index'
import { DEFAULT_CONFIG } from '@/layout/layout/setup/theme-system/config'
import { ENV } from 'public/config'
export default {
  mixins: [mixins],
  components: {
    AccountList,
    Theme2,
    RemoveConfigDialog,
    UpdateSystemName,
    OfficeNetBoard
  },
  data() {
    return {
      isProd: ENV === 'prd',
      isUat: ENV === 'uat',
      isSit: ENV === 'sit',
      authStatus: 1, // 是否开启鉴权
      displayDigitalHumanFlag: true,
      upgradeLogList: [],
      dialogOptions: this.genDialogOptions(),
      isGrayUser: sessionStorage.getItem('GLOBAL_USER_GRAY') === '1',
      grayFlag: document.cookie.includes('gray=1'),
      tips: '按 F11 进入/退出 全屏模式',
      checkRuleInstall: null,
      dropdownItems: [
        {
          key: 'switchAuth',
          command: 'switchAuth',
          isSwitch: true,
          label: '鉴权',
          icon: 'layout-authentication',
          switchValue: () => this.auth,
          visible: () => !this.isProd && !this.isUat && !this.isSit
        },
        {
          key: 'switchGray',
          command: 'switchGray',
          isSwitch: true,
          label: '灰度',
          icon: 'layout-switch',
          switchValue: () => this.grayFlag,
          visible: () => this.isGrayUser
        },
        {
          key: 'otherAccount',
          command: 'otherAccount',
          label: '其他账号',
          icon: 'layout-account',
          visible: () => this.checkAuth('BToOe0ySNoBx')
        },
        {
          key: 'editPassword',
          command: 'editPassword',
          label: '修改密码',
          icon: 'layout-pen1'
        },
        { key: 'divider1', type: 'divider' },
        {
          key: 'appBoard',
          command: 'appBoard',
          label: '产品合集',
          icon: 'layout-collection'
        },
        {
          key: 'setTheme',
          command: 'setTheme',
          label: '主题设置',
          icon: 'layout-theme'
        },
        {
          key: 'showSystemName',
          command: 'showSystemName',
          label: '系统名称',
          icon: 'layout-system-name',
          visible: () => this.checkAuth('BToQFWiq5iP-')
        },
        {
          key: 'clearCache',
          command: 'clearCache',
          label: '清除缓存',
          icon: 'layout-clear1'
        },
        {
          key: 'removeConfig',
          command: 'removeConfig',
          label: '清除配置',
          icon: 'layout-clear2',
          visible: () => this.checkWhiteConfig()
        },
        {
          key: 'resetConfig',
          command: 'resetConfig',
          label: '重置配置',
          icon: 'layout-reset1',
          visible: () => this.checkWhiteConfig()
        },
        { key: 'divider2', type: 'divider' },
        {
          key: 'hotPoint',
          command: 'hotPoint',
          label: '热力图',
          icon: 'layout-heatmap',
          logKey: 'check_rule_hot_map_enter',
          visible: () => this.checkAuth('BToQGEG4JmEO')
        },
        {
          key: 'showScreenFullTips',
          command: 'showScreenFullTips',
          label: '全屏',
          icon: 'layout-full-screen',
          title: '按 F11 进入/退出 全屏模式'
        },
        {
          key: 'checkRule',
          command: 'checkRule',
          label: '页面检测',
          icon: 'layout-check',
          visible: () => this.checkAuth('BToQGEG4JmEO')
        },
        {
          key: 'OfficeNetBoard',
          command: 'OfficeNetBoard',
          component: true,
          visible: () => !!this.user.name
        },
        {
          key: 'switchDigitalHuman',
          command: 'switchDigitalHuman',
          isSwitch: true,
          label: '数字人显示',
          icon: 'layout-hide',
          switchValue: () => this.displayDigitalHumanFlag
        }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    auth() {
      return !!this.authStatus
    },
    hiddenFullScreenAndResizeFlag() {
      return this.dialogOptions.view !== 'UpdateSystemName' && this.dialogOptions.view !== 'RemoveConfigDialog'
    },
    avatar() {
      return this.$store.state.avatar
    }
  },
  mounted() {
    this.$bus.$once('APP_LOADED', this.onAppLoaded)
  },
  methods: {
    onAppLoaded() {
      this.getAuthStatus()
      this.initSystemName()
    },
    /**
     * 获取鉴权状态
     */
    getAuthStatus() {
      this.$http('auth.resource.userValidate', {}, false).then(status => {
        this.authStatus = status
        localStorage.setItem('GLOBAL_AUTH_STATUS', status)
      })
    },
    /**
     * 初始化系统名称
     */
    initSystemName() {
      const hasSystemNameAuth = this.checkAuth('BToQFWiq5iP-')
      if (!hasSystemNameAuth) {
        localStorage.GLOABL_ERP_SYSTEM_NAME = ''
        this.$bus.$emit('SET_SYSTEM_NAME')
      }
    },
    /**
     * 生成弹窗选项
     */
    genDialogOptions() {
      return { title: '', visible: false, view: '', width: null, helper: '', url: '', modal: true }
    },
    /**
     * 关闭帮助弹窗
     */
    closeHelper() {
      this.dialogOptions = this.genDialogOptions()
    },
    // 通用弹窗
    showDynamicDialog(view, title, width = '1200px') {
      this.dialogOptions.visible = true
      this.dialogOptions.view = view
      this.dialogOptions.title = title
      this.dialogOptions.width = width
    },
    /**
     * 处理命令
     */
    handleCommand(val) {
      this[val]()
    },
    /**
     * 处理弹窗显示状态变化
     */
    handleVisibleChange(val) {
      if (val) {
        const { displayDigitalHumanFlag } = { ...DEFAULT_CONFIG, ...(themeSystem.getConfig() || {}) }
        this.displayDigitalHumanFlag = +displayDigitalHumanFlag === 1
      }
    },
    /**
     * 切换鉴权
     */
    switchAuth() {
      let newStatus = this.authStatus === 0 ? 1 : 0
      this.$http('auth.resource.userValidate', { needValidate: newStatus }, false).then(status => {
        this.authStatus = status
        localStorage.setItem('GLOBAL_AUTH_STATUS', status)
        this.$message.success(`鉴权已${newStatus === 0 ? '关闭' : '开启'}，退出系统重新登录后生效`)
      }).catch(_ => {
        this.$message.error('鉴权切换失败，请检查auth.resource.userValidate接口是否正常')
      })
    },
    /**
     * 切换灰度
     */
    switchGray() {
      if (this.grayFlag) {
        let now = new Date()
        now.setTime(now.getTime() - 1)
        document.cookie = `gray=0;expires=${now.toGMTString()}`
      } else {
        document.cookie = `gray=1;`
      }
      this.$message.warning(`正在${this.grayFlag ? '退出' : '进入'}灰度，请稍后操作`)
      setTimeout(() => {
        window.__intercept__ = 0
        location.reload()
      }, 300)
    },

    /**
     * 其他账号
     */
    otherAccount() {
      this.showDynamicDialog('AccountList', '借用账号', '1125px')
    },
    /**
     * 修改密码
     */
    editPassword() {
      this.$router.push('/uamp/edit-password')
    },
    /**
     * 产品合集
     */
    appBoard() {
      this.$router.push('/ams/apps-board')
    },
    /**
     * 主题设置
     */
    setTheme() {
      this.$refs.theme.visible = true
    },
    /**
     * 修改系统名称
     */
    showSystemName() {
      this.showDynamicDialog('UpdateSystemName', '系统名称', '334px')
    },
    /**
     * 清除缓存
     */
    clearCache() {
      localforage.createInstance({ name: 'api' }).clear()
      if (ENV !== 'prd') {
        // 通用查询分组
        localStorage.removeItem('GLOBAL_SEARCH_GENERIC_GROUP')
        // 通用查询
        localStorage.removeItem('GLOBAL_SEARCH_GENERIC')
        // 表格拖拽列宽度
        localStorage.removeItem('GLOBAL_COL_WIDTH')
        // 表格拖拽前配置列宽度
        localStorage.removeItem('GLOBAL_COL_HISTORY_WIDTH')
        // 表格固定列
        localStorage.removeItem('GLOBAL_FIXED_COL')
      }
      this.$http('auth.resource.refreshUserPermissionCache', {}, false)
      this.$message.success('缓存已清除')
      // 清除缓存后需要刷新页面
      location.reload()
    },
    /**
     * 清除配置
     */
    removeConfig() {
      this.showDynamicDialog('RemoveConfigDialog', '清除配置', '334px')
    },
    /**
     * 重置配置
     */
    resetConfig() {
      themeSystem.resetConfig()
      this.$message.success('配置已重置')
      window.__intercept__ = 0
      location.reload()
    },
    /**
     * 热力图
     */
    hotPoint() {
      window.__callWebMonitorPanel()
    },
    // 打开页面检测规范
    async checkRule() {
      if (this.checkRuleInstall) {
        this.checkRuleInstall.open()
        return
      }
      import(/* webpackChunkName: "public-check-rule" */ `@/shared/home-modules/helpers/check-rules/index.vue`).then(res => {
        const Ctor = this.$options._base.extend(res.default)
        this.checkRuleInstall = new Ctor()
        this.checkRuleInstall.$root._routerRoot = this
        this.checkRuleInstall.$mount('#kts-gd-plugin-wrapper')
      })
    },
    /**
     * 全屏
     */
    showScreenFullTips () {
      this.$message(this.tips)
    },
    /**
     * 切换数字人显示
     */
    switchDigitalHuman() {
      this.displayDigitalHumanFlag = !this.displayDigitalHumanFlag
      themeSystem.saveConfig({ displayDigitalHumanFlag: this.displayDigitalHumanFlag ? 1 : 0 })
    },
    /**
     * 退出登录
     */
    logout() {
      this.$store.dispatch('logout')
    },
    /**
     * 检查是否修改配置白名单用户
     */
    checkWhiteConfig() {
      const options = this.lookUpOptions['sys_home_config_white_list'] || []
      const userKey = `${this.user.employeeNumber}${this.user.name}`
      return options.some(item => `${item.value}${item.label}` === userKey)
    },
    /**
     * 权限判断
     */
    checkAuth(auth) {
      let permission = this.$store.state.permission.menus || []
      return permission.includes(auth)
    }
  }
}

</script>
<style lang='scss'>
.layout-header-dropdown-menu {
  .info-wrap {
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 28px;
    padding: 2px;
    padding-right: 8px;
    border-radius: 16px;
    color: var(--g-theme-header-action-color-text);
    background-color: var(--g-theme-header-action-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      color: var(--g-theme-header-action-color-text-hover);
      background-color: var(--g-theme-header-action-bg-hover);
    }

    .user-avatar {
      width: 24px;
      height: 24px;
      text-align: center;
      border-radius: 50%;
      margin-right: 4px;
      i {
        font-size: 24px;
        color: #4d26bf;
      }

      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }

    .el-icon-caret-bottom {
      padding-left: 8px;
      color: #ffffff;
    }

    .info {
      color: #ffffff;

      p {
        font-weight: bold;
        font-size: 14px;
        line-height: 14px;
      }
    }
  }
}
.layout-header-dropdown {
  width: 254px;
  padding: 12px;
  border-radius: 12px;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    line-height: 36px;
    font-size: 14px;
    color: #453c5a;
    padding: 0 10px;

    &:active,
    &:hover {
      background-color: #F7F7FF !important;
      color: #453C5A !important;
      border-radius: 10px;
    }

    .switch-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 36px;

      &>div:first-child {
        display: flex;
        align-items: center;
      }
    }
  }

  .logout-item-wrap {
    margin-top: 4px;
    padding: 0;
  }

  .header-user-dropitem-line {
    width: 100%;
    height: 1px;
    margin: 4px 0;
    background-color: rgba(108, 60, 244, .1);
  }

  .user-info-wrap {
    display: flex;
    background: url('../layout/images/user-info-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 4px;
    padding: 12px;
    border-radius: 8px;

    .user-info {
      display: flex;
      align-items: center;

      .user-avatar {
        width: 42px;
        height: 42px;

        img {
          display: block;
          width: 42px;
          height: 42px;
          border-radius: 50%;
        }
      }

      .user {
        margin-left: 9px;
        line-height: normal;

        .user-name {
          color: rgba(68, 62, 82, 1);
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 2px;
        }

        .user-duty {
          color: rgba(86, 80, 99, 1);
          font-size: 13px;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }
  }

  .logout-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-radius: 8px;
    background: rgba(247, 248, 250, 1);
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: #453c5a;
    cursor: pointer;

    &:hover {
      background: rgba(235, 239, 245, 1);
    }
  }
  .header-user-dropitem {
    font-size: 20px;
    margin-right: 8px;
    color: rgba(69, 60, 90, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/dropdown-menu.vue